import { z } from 'zod';

export const JwtPayloadSchema = z.object({
  sub: z.string(),
  id: z.number(),
  nome: z.string(),
  // OPCIONAL de propósito, apesar de o backend já emitir sempre. Pela ADR-001,
  // uma falha deste parse limpa o sessionStorage e força relogin — exigir a
  // claim deslogaria todo usuário com token emitido ANTES do deploy do backend,
  // inclusive no meio do trabalho, e durante deploy escalonado os dois formatos
  // de token circulam juntos. Consumidores fazem fallback para `nome`.
  // Pode virar obrigatória quando todos os tokens antigos tiverem expirado.
  nomeCompleto: z.string().optional(),
  role: z.enum(['ROLE_USER', 'ROLE_ADMIN', 'ROLE_MASTER']),
  penultimo_acesso: z.string().nullable(),
  permissoes: z.record(z.string(), z.record(z.string(), z.boolean())).optional(),
  lojasAcesso: z.array(z.unknown()).optional(),
  codUsuarioIntegracao: z.number().nullable().optional(),
  iat: z.number().optional(),
  exp: z.number(),
});

export type JwtPayload = z.infer<typeof JwtPayloadSchema>;
